import { useEffect, useRef } from "react";
import "./App.css";
import LandingPage from "./components/LandingPage";
import Navbar from "./components/Navbar";
import TabsComponent from "./components/TabsComponent";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import DownloadSection from "./components/DownloadSection";
import ImageSlider from "./components/ImageSlider";
import ImageSlider2 from "./components/ImageSlider2";
import Footer from "./components/Footer";
import PricingCards from "./components/PricingCards";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

function App() {
  const gradientRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Gradient position animation
    gsap.fromTo(gradientRef.current,
      { backgroundPosition: "0% 0%" },
      {
        backgroundPosition: "100% 100%",
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          end: "bottom bottom",
          scrub: 1.5,
        },
      }
    );

    // Color intensity animation
    gsap.fromTo(gradientRef.current,
      { 
        backgroundImage: "linear-gradient(315deg, #0a0c24 0%, #1a1b3a 50%,rgb(23, 5, 24) 100%)" 
      },
      {
        backgroundImage: "linear-gradient(315deg, #050814 0%, #0f1028 50%, #1a081b 100%)",
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top center",
          end: "bottom center",
          scrub: 1,
        },
      }
    );
  }, []);

  return (
    <div className="App" ref={containerRef}>
      <div ref={gradientRef} className="gradientBackground" />
      <Navbar />
      <br/>
      <LandingPage />
      <ImageSlider />
      <ImageSlider2 />
      <TabsComponent />
      <PricingCards />
      <DownloadSection />
      <Footer />
    </div>
  );
}

export default App;